<script>
    export let id
</script>

<div class="anchor" {id} />

<style lang="scss">
    .anchor {
        position: absolute;
        width: 100%;
        height: 1px;
        top: -88px;
        left: 0;
    }
</style>